import { useEffect, useState } from 'react';
import { DialogPageOptions, useDialogContext } from './DialogContext';

export function useRegisterDialogPage(
  pageId: string,
  pageOptions: DialogPageOptions
): number | null {
  const { registerPage, unregisterPage } = useDialogContext();
  const [pageNumber, setPageNumber] = useState<number | null>(null);

  useEffect(() => {
    console.log('Registering page:', pageId, pageOptions);
    setPageNumber(registerPage(pageId, pageOptions));

    return () => {
      unregisterPage(pageId);
    };
  }, [pageId, registerPage, unregisterPage, setPageNumber]);

  return pageNumber;
}
